/**
 * Die Wahl eines Bots am freien Farbplatz (`L2`, **E104**, **E110**; seit `L4` nur die Stufe,
 * **E127**).
 *
 * **Seit dem 2026-10-13 nur noch Name, Stufe und „Bot einsetzen"** (Entscheidung des User,
 * **E127**): *„Den genauer-Button nehmen wir raus und behalten ausschließlich das Dropdown"*.
 * Strategie, Tiefe, Gewichte und das Sprachmodell unter „genauer" (E110) sind aus der Lobby
 * entfernt — der LLM-Spieler ist zurückgestellt (sieben Partien gegen den User, keine gewonnen,
 * schwächer als `stark`), und das Labor erreicht die Strategien weiter über die API und
 * `pnpm sim`. Damit ist auch die Falle aus Wartelisten-Punkt 13 weg: eine Stufe, die nach dem
 * Aufklappen still etwas anderes hinausschickte.
 *
 * **Was hinausgeht, ist eine Wahl, keine Definition** (**E108**): immer `{ kind: 'LEVEL' }`;
 * Strategie, Ausführungsart und Budget setzt der Dienst (`levels.ts`).
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BOT_LEVELS, type BotChoice, type BotLevel } from '@flaghex/contracts';

const SEPARATOR = ' · ';

export interface BotChooserProps {
  readonly sector: string;
  readonly onAdd: (displayName: string, choice: BotChoice) => void;
}

export function BotChooser({ sector, onAdd }: BotChooserProps) {
  const { t } = useTranslation(['lobby']);
  const [name, setName] = useState('');
  const [level, setLevel] = useState<BotLevel>('medium');

  return (
    <>
      <label>
        {t('lobby:host.botName')}{' '}
        <input
          type="text"
          data-bot-name={sector}
          value={name}
          onChange={(event) => setName(event.target.value)}
        />
      </label>
      {SEPARATOR}
      <label>
        {t('lobby:bot.level')}{' '}
        <select
          data-bot-level={sector}
          value={level}
          onChange={(event) => setLevel(event.target.value as BotLevel)}
        >
          {BOT_LEVELS.map((entry) => (
            <option key={entry} value={entry}>
              {t(`lobby:bot.levels.${entry}`)}
            </option>
          ))}
        </select>
      </label>
      {SEPARATOR}
      {/*
        **Ein leeres Feld sperrt den Knopf** (**E64**, Folge 1) — geprüft wird der beschnittene
        Wert, Leerraum allein ist kein Name.
      */}
      <button
        type="button"
        data-bot-add={sector}
        disabled={name.trim() === ''}
        onClick={() => onAdd(name.trim(), { kind: 'LEVEL', level })}
      >
        {t('lobby:host.addBot')}
      </button>
    </>
  );
}
